// extracted by mini-css-extract-plugin
module.exports = {"BorderedSwitch":"SettingsCoverImage_BorderedSwitch___9JqT","CTAContainer":"SettingsCoverImage_CTAContainer__3T75n","Heading":"SettingsCoverImage_Heading__Ycye-"};